import BaseEntity from '../../base/BaseEntity.model';
import Persona from '@/models/persona/persona.model';
import SolicitudCambioComposicionFamiliarDocumento from './documento.model';

export default class SolicitudCambioComposicionFamiliarExclusion extends BaseEntity {
    public solicitudCambioComposicionFamiliarId?: number;
    public motivoExclusion?: string;
    public codHogar?: string;
    public codHogarSiuben?: string;

    public persona?: Persona;
    public parentescoNombre?: string;
    public documentos?: SolicitudCambioComposicionFamiliarDocumento[];

    public miembroSiubenId?: number;
    public razonExclusionId?: number;
    public razonMuerte?: string;
    public fechaFallecimiento?: Date;

    public cedulaQuienPoseeMenor?: string;
    public parentescoQuienPoseeMenorId?: number;

    constructor(public hogarId: number | undefined = undefined, public miembroId: number | undefined = undefined, public personaId: number | undefined = undefined) {
        super();
        this.solicitudCambioComposicionFamiliarId = undefined;
        this.motivoExclusion = undefined;
        this.parentescoNombre = undefined;
        this.persona = undefined;
        this.miembroSiubenId = undefined;
        this.documentos = [];
    }
}

